export default function SantaHat({ color = '#E31B23', style, className }) {
  return (
    <svg
      viewBox="0 0 120 100"
      className={className}
      style={style}
      aria-hidden="true"
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* cuerpo del gorro */}
      <path
        d="M14 74 C16 34 46 8 80 14 C92 16 102 24 106 36 C108 46 108 62 106 74 Z"
        fill={color}
      />
      {/* sombra suave del lado derecho */}
      <path
        d="M70 16 C92 16 102 24 106 36 C108 46 108 62 106 74 L84 74 C90 52 84 30 70 16 Z"
        fill="#000"
        opacity="0.14"
      />
      {/* pompón */}
      <circle cx="104" cy="36" r="11" fill="#fff" />
      {/* borde de piel */}
      <rect x="6" y="66" width="104" height="26" rx="13" fill="#fff" />
      <rect x="6" y="66" width="104" height="26" rx="13" fill="none" stroke="#dfe6ee" strokeWidth="1.5" />
    </svg>
  );
}